import React, { useState, useEffect } from "react";
import { Constants } from "@eagerdog/constants";
import { IShow, IRunningOrder } from "@eagerdog/interfaces";

import Dropdown, { IOption } from "src/components/Dropdown/Dropdown";
import Button from "src/components/Button/Button";

import styles from "./index.module.scss";

interface IProps {
  currentRing: string;
  currentJudgeName: string;
  show: IShow;
  ringOptions: IOption[];
  onFinish(targetRing: string, targetJudgeName: string, targetJudgeNumber: string): void | Promise<void>;
}

const MoveClassToRing: React.FC<IProps> = (props) => {
  const [selectedRing, setSelectedRing] = useState<IOption>({ id: Constants.none, value: "Select a Ring" });
  const [selectedJudge, setSelectedJudge] = useState<IOption>({ id: Constants.none, value: "Select a Judge" });
  const [judgeOptions, setJudgeOptions] = useState<IOption[]>([]);

  useEffect(() => {
    if (selectedRing.id === Constants.none) {
      setJudgeOptions([]);
      setSelectedJudge({ id: Constants.none, value: "Select a Judge" });
      return;
    }

    const ring = props.show.rings?.find((r: any) => r.ring === selectedRing.id);
    const options: IOption[] = (ring?.running_order || [])
      .filter((ro: IRunningOrder) => !!ro.judge_name)
      .map((ro: IRunningOrder) => ({
        id: `${ro.judge_name}||${ro.judge_number || ""}`,
        value: ro.judge_number ? `${ro.judge_name} (${ro.judge_number})` : ro.judge_name,
      }));

    setJudgeOptions(options);
    setSelectedJudge(options.length === 1 ? options[0] : { id: Constants.none, value: "Select a Judge" });
  }, [selectedRing, props.show]);

  const canConfirm = selectedRing.id !== Constants.none && selectedJudge.id !== Constants.none;

  const handleConfirm = () => {
    const [judgeName, judgeNumber] = selectedJudge.id.split("||");
    props.onFinish(selectedRing.id, judgeName, judgeNumber);
  };

  return (
    <div className={styles.MoveClassToRing}>
      <div className={styles.title}>Move Class to Ring</div>
      <Dropdown
        value={selectedRing}
        onChange={(_e: any, value: IOption) => setSelectedRing(value)}
        label="Target Ring"
        options={props.ringOptions.filter((o) => o.id !== props.currentRing)}
        placeholder="Select a Ring"
      />
      {selectedRing.id !== Constants.none && (
        <Dropdown
          value={selectedJudge}
          onChange={(_e: any, value: IOption) => setSelectedJudge(value)}
          label="Target Judge"
          options={judgeOptions}
          placeholder="Select a Judge"
        />
      )}
      <div className={styles.actions}>
        <Button disabled={!canConfirm} onClick={handleConfirm}>Confirm</Button>
      </div>
    </div>
  );
};

export { MoveClassToRing };
